import { Grid } from '@mui/material';
import { Fragment, memo } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';
import { FormikErrors, FormikTouched } from 'formik';
import { SectionVM } from 'civil-status/view-models/step-form';
import { useEventCallback } from '@mui/material';
import { DatePicker } from '@mui/lab';
import ListTemplateTranscription, { ItemTemplateVM } from '../list/list-template-transcription';

interface FormTratxtBaseProps {
  onChange: (key: keyof SectionVM, value: SectionVM[keyof SectionVM]) => void;
  onChanges: (values: SectionVM) => void;
  values?: SectionVM;
  errors?: FormikErrors<SectionVM>;
  touched?: FormikTouched<SectionVM>;
  configuration?: string;
  tipoEvento?: string;
  idUseCase?: string;
  idEvento?: number;
  idDominio?: string;
  disabled?: boolean;
  labelData?: string;
  labelText?: string;
  isTraneGass?: boolean;
}

const FormTratxtBaseComponent = ({
  onChange,
  onChanges,
  values,
  errors,
  touched,
  tipoEvento,
  idUseCase,
  idEvento,
  idDominio,
  disabled = false,
  labelData = 'Data richiesta trascrizione *',
  labelText = "Testo dell'atto da trascrivere *",
  isTraneGass = false,
}: FormTratxtBaseProps): React.ReactElement => {
  const handleListTemplateTranscriptionChange = useEventCallback((value?: ItemTemplateVM) => {
    onChanges({
      ...(values || {}),
      templateTranscription: value?.id?.toString(),
      templateTranscriptionText: value?.valueTemplate || '',
    });
  });

  const handleListTemplateTranscriptionChangeInitialize = useEventCallback(
    (value?: ItemTemplateVM) => {
      if (values?.templateTranscriptionText) {
        // se già inizializzato non modificare
        return;
      }

      onChanges({
        ...(values || {}),
        templateTranscription: value?.id?.toString(),
        templateTranscriptionText: value?.valueTemplate || '',
      });
    }
  );

  return (
    <Fragment>
      <Grid item xs={12} md={4}>
        <DatePicker
          label={labelData}
          aria-label={labelData}
          value={values?.dateTranscription || null}
          onChange={(date) => {
            onChange('dateTranscription', date);
          }}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateTranscription"
              fullWidth
              helperText={errors?.dateTranscription}
              error={touched?.dateTranscription && Boolean(errors?.dateTranscription)}
            />
          )}
        />
      </Grid>
      {isTraneGass ? (
        <Grid item xs={12} md={4}>
          <DatePicker
            label="Data stipula accordo *"
            aria-label="Data stipula accordo"
            value={values?.dateStipulation || null}
            onChange={(date) => {
              onChange('dateStipulation', date);
            }}
            disabled={disabled}
            renderInput={(params) => (
              <PmiTextField
                {...params}
                id="dateStipulation"
                fullWidth
                helperText={errors?.dateStipulation}
                error={touched?.dateStipulation && Boolean(errors?.dateStipulation)}
              />
            )}
          />
        </Grid>
      ) : undefined}
      <Grid item xs={12}>
        <ListTemplateTranscription
          value={values?.templateTranscription || ''}
          onChange={handleListTemplateTranscriptionChange}
          onChangeInitialize={handleListTemplateTranscriptionChangeInitialize}
          toInitializeId={values?.idTemplateIcaro}
          tipoEvento={tipoEvento}
          idUseCase={idUseCase}
          idEvento={idEvento}
          disabled={disabled || values?.disableTemplate}
          idDominio={idDominio}
          error={Boolean(errors?.templateTranscription) && touched?.templateTranscription}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          label={labelText}
          aria-label={labelText}
          id="templateTranscriptionText"
          name="templateTranscriptionText"
          fullWidth
          type="text"
          variant="outlined"
          multiline
          rows={10}
          value={values?.templateTranscriptionText || ''}
          onChange={(event) => {
            onChange('templateTranscriptionText', event.target.value);
          }}
          error={touched?.templateTranscriptionText && Boolean(errors?.templateTranscriptionText)}
          helperText={errors?.templateTranscriptionText}
          disabled={disabled}
        />
      </Grid>
    </Fragment>
  );
};

FormTratxtBaseComponent.displayName = 'Form Transcription Data - Form TratxtBase component';

const FormTratxtBase = memo(FormTratxtBaseComponent);

export default FormTratxtBase;
